export {RegionalUserAgreementComponent} from './rua.component'
